<template>
  <div class="container">
    <div class="banner">Theatres</div>
    <div class="grid">
      <div class="grid__row" v-for="(row, rowIndex) in array" :key="rowIndex">
        <div
          class="grid__column"
          v-for="(column, columnIndex) in row"
          :key="columnIndex"
        >
          <img :src="column.img" />
          <div class="grid__column__name">{{ column.name }}</div>
          <div class="grid__column__city">{{ column.city }}</div>
        </div>
      </div>
      <div v-if="visible.more" class="more" to="/about-us/brief" @click="onMoreClick">
        {{ $t("Read More") }}<i class="iconfont acog-gengduo more__arrow"></i>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../components/Footer";
export default {
  data() {
    return {
      visible: {
        more: true
      },
      array: [
        [
          {
            img: require("../assets/theatres_1.png"),
            name: "Nanshan Cultural and Sports Center",
            city: "Shenzhen,China"
          },
          {
            img: require("../assets/theatres_2.png"),
            name: "Shijiazhuang  Grand Theatre",
            city: "Shijiazhuang,China"
          },
          {
            img: require("../assets/theatres_3.png"),
            name: "Putuo Grand Theatre",
            city: "Zhoushan,China"
          }
        ],
        [
          {
            img: require("../assets/theatres_4.png"),
            name: "Tianyuan Arts Centre of Wuyishan New Area",
            city: "Nanping,China"
          },
          {
            img: require("../assets/theatres_5.png"),
            name: "Yinshanhu Grand Theatre of Suzhou",
            city: "Suzhou,China"
          },
          {
            img: require("../assets/theatres_6.png"),
            name: "Gu’an Grand Theatre",
            city: "Langfang,China"
          }
        ],
        [
          {
            img: require("../assets/theatres_7.png"),
            name: "Yaohai  Grand Theatre of Hefei",
            city: "Hefei,China"
          },
          {
            img: require("../assets/theatres_8.png"),
            name: "Ulan Muqir Palace Grand Theatre",
            city: "Ulanhot,China"
          },
          {
            img: require("../assets/theatres_9.png"),
            name: "Xinqiao Culture Arts Centre of Shenzhen",
            city: "Shenzhen,China"
          }
        ],
        [
          {
            img: require("../assets/theatres_10.png"),
            name: "Suzhou Kunqu Opera Theatre of Jiangsu",
            city: "Suzhou,China"
          },
          {
            img: require("../assets/theatres_11.png"),
            name: "Chongqing Culture Palace Grand Theatre",
            city: "Chongqing,China"
          },
          {
            img: require("../assets/theatres_12.png"),
            name: "Agile Clearwater Bay Arts Centre",
            city: "Lingshui,China"
          }
        ]
      ]
    };
  },
  methods: {
    onMoreClick() {
      this.visible.more = false;
      this.array = this.array.concat([
        [
          {
            img: require("../assets/theatres_13.png"),
            name: this.$t("The Marionette Theatre Of Quanzhou"),
            city: this.$t("Quanzhou,China")
          },
          {
            img: require("../assets/theatres_14.png"),
            name: this.$t("Shanghai ‘KE’ Contemporary Arts Centre"),
            city: this.$t("Shanghai,China")
          },
          {
            img: require("../assets/theatres_15.png"),
            name: this.$t("Yichang Theatre"),
            city: this.$t("Yichang,China")
          }
        ],
        [
          {
            img: require("../assets/theatres_16.png"),
            name: this.$t("Guangzhou TaiGuCang Wharf"),
            city: this.$t("Guangzhou,China")
          },
          {
            img: require("../assets/theatres_17.png"),
            name: this.$t("Ninghai Culture Complex"),
            city: this.$t("Ninghai,China")
          },
          {
            img: require("../assets/theatres_18.png"),
            name: this.$t("Liu Gang Culture Center"),
            city: this.$t("Liuzhou,China")
          }
        ]
      ]);
    }
  },
  components: {
    Footer
  }
};
</script>
<style lang="scss" scoped>
.container {
  .banner {
    height: 312px;
    background-image: url("../assets/productions_banner.png");
    background-position: center;
    background-repeat: no-repeat;
    line-height: 312px;
    font-size: 40px;
    color: #fefefe;
    text-align: center;
  }
  .grid {
    padding-top: 72px;
    padding-bottom: 72px;
    box-sizing: border-box;
    text-align: center;
    &__row {
      text-align: center;
    }
    &__column {
      display: inline-block;
      width: 358px;
      height: 422px;
      text-align: left;
      vertical-align: top;
      &__name {
        margin-top: 10px;
        width: 347px;
        font-size: 24px;
        font-weight: bold;
        text-align: left;
        color: rgba(35, 35, 35, 1);
      }
      &__city {
        margin-top: 10px;
        font-size: 22px;
        font-weight: 300;
        color: rgba(35, 35, 35, 1);
      }
    }
  }
  .grid__column:not(:first-child) {
    margin-left: 63px;
  }
  .more {
    width: 232px;
    height: 46px;
    border: 1px solid rgba(236, 105, 0, 1);
    border-radius: 23px;
    display: inline-block;
    text-align: center;
    line-height: 46px;
    color: rgba(236, 105, 0, 1);
    &__arrow {
      margin-left: 2px;
      font-size: 10px;
      vertical-align: middle;
    }
  }
}
</style>